export enum OrganizationUserRole {
    ADMIN = 'ADMIN',
    USER = 'USER',
}

export const OrganizationUserRoleLabel: { [key in OrganizationUserRole]: string } = {
    [OrganizationUserRole.ADMIN]: 'Admin',
    [OrganizationUserRole.USER]: 'User',
};
